import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import RealtimeExtend from 'ext:flarum/realtime/forum/extenders/Realtime';
import addRealtimeTypingIndicator from './addRealtimeTypingIndicator';
const MESSAGE_CREATED_EVENT = 'Flarum\\Messages\\DialogMessage\\Event\\Created';
export default function extendRealtime() {
  new RealtimeExtend().onUserChannelEvent(MESSAGE_CREATED_EVENT, data => {
    var _dropdownDialogs, _dropdownDialogs$refr, _dialogs, _dialogs$refresh;
    app.store.pushPayload(data);
    (_dropdownDialogs = app.dropdownDialogs) == null || (_dropdownDialogs$refr = _dropdownDialogs.refresh) == null || _dropdownDialogs$refr.call(_dropdownDialogs);
    (_dialogs = app.dialogs) == null || (_dialogs$refresh = _dialogs.refresh) == null || _dialogs$refresh.call(_dialogs);
  }).extend(app, {
    name: 'flarum-messages',
    exports: {}
  });

  // Bind the new message event on MessageStream so we can access
  // the stream state directly and push the message in without a full reload.
  extend('ext:flarum/messages/forum/components/MessageStream', 'oninit', function () {
    this.messageCreatedHandler = data => {
      var _message$dialog, _this$attrs;
      const message = app.store.pushPayload(data);
      if ((message == null || (_message$dialog = message.dialog) == null || (_message$dialog = _message$dialog.call(message)) == null ? void 0 : _message$dialog.id()) === ((_this$attrs = this.attrs) == null || (_this$attrs = _this$attrs.dialog) == null ? void 0 : _this$attrs.id()) && this.attrs.state.hasItems()) {
        this.attrs.state.push(message);
        setTimeout(() => this.scrollToBottom(), 50);
      }
    };
  });
  extend('ext:flarum/messages/forum/components/MessageStream', 'oncreate', function () {
    var _app$websocket_channe;
    (_app$websocket_channe = app.websocket_channels) == null || (_app$websocket_channe = _app$websocket_channe.user) == null || _app$websocket_channe.bind(MESSAGE_CREATED_EVENT, this.messageCreatedHandler);
  });
  extend('ext:flarum/messages/forum/components/MessageStream', 'onremove', function () {
    var _app$websocket_channe2;
    (_app$websocket_channe2 = app.websocket_channels) == null || (_app$websocket_channe2 = _app$websocket_channe2.user) == null || _app$websocket_channe2.unbind(MESSAGE_CREATED_EVENT, this.messageCreatedHandler);
  });
  addRealtimeTypingIndicator();
}